import React from 'react';
import { ArrowRight } from "lucide-react";
var getSaldoBgColor = function (dias) {
    if (dias === undefined || dias === null)
        return "bg-gradient-to-r from-gray-800 to-gray-800";
    if (dias > 0 && dias < 3)
        return "bg-orange-600"; // Laranja forte
    if (dias >= 3 && dias < 6)
        return "bg-[#8f5600]"; // Amarelo
    return "bg-gradient-to-r from-gray-800 to-gray-800"; // Normal
};
var InstagramMetricItem = function (_a) {
    var label = _a.label, value = _a.value, _b = _a.color, color = _b === void 0 ? '#ffffff' : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.classAdd, classAdd = _d === void 0 ? null : _d, daysRemaining = _a.daysRemaining, link = _a.link, _e = _a.disableZeroBlink, disableZeroBlink = _e === void 0 ? false : _e, // NOVO PADRÃO
    _f = _a.account_stopped, // NOVO PADRÃO
    account_stopped = _f === void 0 ? false : _f;
    var sizeClasses = {
        small: 'text-sm',
        normal: 'text-base',
        large: 'text-lg',
    };
    // Arredonda daysRemaining para baixo, se existir
    var roundedDays = typeof daysRemaining === "number" ? Math.floor(daysRemaining) : undefined;
    // Verifica se o valor é zero
    var isZero = value === '0' ||
        value === 'R$ 0' ||
        value === 'R$ 0,00' ||
        /\|\s*0\s*dia/.test(String(value)) ||
        value == "| 0 dia";
    // Novo: considera isZero OU account_stopped
    var isZeroOrStopped = isZero || account_stopped;
    // Aplica cor de fundo especial se daysRemaining for passado e não for zero/parada
    var bgClass = !isZeroOrStopped && daysRemaining !== undefined
        ? getSaldoBgColor(daysRemaining)
        : (isZeroOrStopped
            ? (disableZeroBlink ? 'bg-gradient-to-r from-gray-800 to-gray-800' : 'metric-zero blink')
            : 'bg-gradient-to-r from-gray-800 to-gray-800');
    return (React.createElement("div", { className: "pt-0.5 pb-0.5 pr-1 2xl:pr-2.5 pl-1 2xl:pl-2.5 rounded-lg flex flex-col justify-between h-full text-white-fallback " +
            bgClass +
            (classAdd ? " ".concat(classAdd) : ''), title: account_stopped
            ? "ATENÇÃO: conta sem atividade desde a ultima atualização."
            : null },
        React.createElement("div", { className: "text-[10px] 2xl:text-xs text-gray-400 mb-1 flex items-center justify-between" },
            label,
            link && (React.createElement("a", { href: link, target: "_blank", rel: "noopener noreferrer", className: "ml-2 px-1 rounded-full hover:bg-blue-600/20 transition flex items-center justify-center", title: "Acessar", style: { lineHeight: 0 } },
                React.createElement(ArrowRight, { className: "w-4 h-4 text-blue-400 " })))),
        React.createElement("div", { className: "font-medium ".concat(sizeClasses[size], " truncate"), style: { color: isZeroOrStopped ? 'white' : color } }, typeof value === "string" && value.includes("dias") && roundedDays !== undefined
            ? value.replace(/(\d+)([.,]?\d*)\s*dias/, "".concat(roundedDays, " dias"))
            : value)));
};
export default InstagramMetricItem;
